import { type ReactNode } from 'react'

import { Icon } from '@/components/icons/Icon'
import { isIconType } from '@/defs/icon'

import styles from './Mana.module.scss'

type Props = {
  colors?: string[]
}

export const Mana = ({ colors }: Props) => {
  if (!colors) return null

  return (
    <span className={styles.container}>
      {colors.map<ReactNode>((value, i) => {
        const icon = `mtg-${value.toLowerCase().replaceAll('/', '')}`
        return isIconType(icon) ? <Icon key={i} name={icon} /> : <span key={i}>{value}</span>
      })}
    </span>
  )
}
